import * as API from "../api/SessionApi";
import AppState from '../state/AppState';

export const login = (email, password) => {
  return API.login(email, password)
    .then((result) => {

      if (typeof FS !== "undefined")
        FS.identify(result.user.id, {
          email: result.user.email,
          gf_premium: result.user.gf_premium,
          customer_id: result.user.customer_id
        });
      AppState.login(result.user)
    })
};

export const logout = () => {
  return API.logout()
    .then((result) => AppState.logout())
};


// WEBPACK FOOTER //
// ./src/actions/SessionActions.js